import React from "react";
import dayjs from "dayjs";
import { useGetLeadPrimary } from "api/leads-management/query";
import "dayjs/locale/id";

// Assets
import Hot from "assets/hot.png";
import Warm from "assets/warm.png";
import Cold from "assets/cold.png";

dayjs.locale("id");

const ModalLeadDetail = ({ isOpen, onClose, leadId }) => {
  const { data: leadData, isLoading } = useGetLeadPrimary({
    leadId,
    enabled: isOpen && !!leadId,
  });

  const lead = leadData?.data?.data;

  const _getBadge = (status = "") => {
    switch (status.toLowerCase()) {
      case "warm":
        return (
          <div
            style={{ fontSize: "11px" }}
            className="text-[#C38022] rounded-[12px] py-0.5 flex items-center gap-0.5 pr-2 bg-[linear-gradient(90deg,#FFF3C9_0%,_#F2CA8C_100%)]"
          >
            <img
              className="w-[18px] aspect-square object-contain"
              src={Warm}
              alt="warm"
            />
            WARM
          </div>
        );
      case "hot":
        return (
          <div
            style={{ fontSize: "11px" }}
            className="text-[#fff] rounded-[12px] py-0.5 flex items-center gap-0.5 pr-2 bg-[linear-gradient(90deg,#FFE9E6_0%,_#F33D26_100%)]"
          >
            <img
              className="w-[18px] aspect-square object-contain"
              src={Hot}
              alt="hot"
            />
            HOT
          </div>
        );
      case "cold":
        return (
          <div
            style={{ fontSize: "11px" }}
            className="text-[#5286A4] rounded-[12px] py-0.5 flex items-center gap-0.5 pr-2 bg-[linear-gradient(90deg,#F1F7F8_0%,_#B4D3DE_100%)]"
          >
            <img
              className="w-[18px] aspect-square object-contain"
              src={Cold}
              alt="cold"
            />
            COLD
          </div>
        );
      default:
        return null;
    }
  };

  const hasComments = lead?.lead_comments?.length > 0;

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]"
      onClick={onClose}
    >
      <div className="bg-white rounded-lg min-w-[500px] max-h-[90vh] overflow-y-auto shadow-[0px_4px_20px_rgba(0,0,0,0.15)]">
        {/* Header */}
        <div className="flex justify-between items-center px-6 pt-6 pb-4 border-b border-[#D8D8D9]">
          <h2 className="font-inter font-semibold text-[17px]/[27px] tracking-[-0.4px] text-[#252526]">
            Detail Leads
          </h2>
          <button onClick={onClose}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M11.4018 10.4735C11.5251 10.5968 11.5943 10.764 11.5943 10.9383C11.5943 11.1127 11.5251 11.2799 11.4018 11.4032C11.2785 11.5265 11.1113 11.5957 10.9369 11.5957C10.7626 11.5957 10.5954 11.5265 10.4721 11.4032L6.99998 7.92997L3.52677 11.4021C3.40349 11.5254 3.23628 11.5946 3.06193 11.5946C2.88758 11.5946 2.72037 11.5254 2.59709 11.4021C2.4738 11.2788 2.40454 11.1116 2.40454 10.9372C2.40454 10.7629 2.4738 10.5957 2.59709 10.4724L6.07029 7.00028L2.59818 3.52708C2.4749 3.40379 2.40563 3.23658 2.40563 3.06223C2.40563 2.88788 2.4749 2.72067 2.59818 2.59739C2.72146 2.4741 2.88867 2.40484 3.06302 2.40484C3.23737 2.40484 3.40458 2.4741 3.52787 2.59739L6.99998 6.07059L10.4732 2.59684C10.5965 2.47356 10.7637 2.4043 10.938 2.4043C11.1124 2.4043 11.2796 2.47356 11.4029 2.59684C11.5262 2.72013 11.5954 2.88733 11.5954 3.06169C11.5954 3.23604 11.5262 3.40324 11.4029 3.52653L7.92966 7.00028L11.4018 10.4735Z"
                fill="#808285"
              />
            </svg>
          </button>
        </div>
        <div className="flex items-start">
          {/* LEFT */}
          <div className="w-full">
            {/* Labels */}
            <div className="h-[40px] flex items-center gap-2 py-2 px-6 border-b border-t border-solid mb-2 border-[#D8D8D9]">
              <span className="rounded-[4px] text-[11px] font-medium text-[#252526] bg-[#E6E7E8] px-2 py-0.5">
                {lead?.project_name}
              </span>
              <span className="rounded-[4px] text-[11px] font-medium text-[#252526] bg-[#E6E7E8] px-2 py-0.5">
                #{lead?.id}
              </span>
              <span className="rounded-[4px] text-[11px] font-medium text-[#252526] bg-[#E6E7E8] px-2 py-0.5 flex items-center gap-1">
                {`${lead?.score}`}
                <span className="!text-[#808285]">/100</span>
              </span>
            </div>

            {/* Info customer */}
            <div className="py-2 px-6 border-b mb-2 border-dashed border-[#D8D8D9]">
              <p className="text-[11px]/[17px] text-[#808285] mb-2">
                Info customer:
              </p>
              <p className="text-[13px]/[21px] text-[#252526] mb-2">
                {lead?.name}
              </p>
              <div className="flex items-center gap-2 mb-2">
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <path
                      d="M7 0.5C5.71442 0.5 4.45772 0.881218 3.3888 1.59545C2.31988 2.30968 1.48676 3.32484 0.994786 4.51256C0.502816 5.70028 0.374095 7.00721 0.624899 8.26809C0.875703 9.52896 1.49477 10.6872 2.40381 11.5962C3.31285 12.5052 4.47104 13.1243 5.73192 13.3751C6.99279 13.6259 8.29973 13.4972 9.48744 13.0052C10.6752 12.5132 11.6903 11.6801 12.4046 10.6112C13.1188 9.54229 13.5 8.28558 13.5 7C13.4982 5.27665 12.8128 3.62441 11.5942 2.40582C10.3756 1.18722 8.72335 0.50182 7 0.5ZM6.75 3.5C6.89834 3.5 7.04334 3.54399 7.16668 3.6264C7.29002 3.70881 7.38615 3.82594 7.44291 3.96299C7.49968 4.10003 7.51453 4.25083 7.48559 4.39632C7.45665 4.5418 7.38522 4.67544 7.28033 4.78033C7.17544 4.88522 7.04181 4.95665 6.89632 4.98559C6.75084 5.01453 6.60003 4.99968 6.46299 4.94291C6.32595 4.88614 6.20881 4.79001 6.1264 4.66668C6.04399 4.54334 6 4.39834 6 4.25C6 4.05109 6.07902 3.86032 6.21967 3.71967C6.36032 3.57902 6.55109 3.5 6.75 3.5ZM7.5 10.5C7.23479 10.5 6.98043 10.3946 6.7929 10.2071C6.60536 10.0196 6.5 9.76522 6.5 9.5V7C6.36739 7 6.24022 6.94732 6.14645 6.85355C6.05268 6.75979 6 6.63261 6 6.5C6 6.36739 6.05268 6.24021 6.14645 6.14645C6.24022 6.05268 6.36739 6 6.5 6C6.76522 6 7.01957 6.10536 7.20711 6.29289C7.39465 6.48043 7.5 6.73478 7.5 7V9.5C7.63261 9.5 7.75979 9.55268 7.85356 9.64645C7.94732 9.74021 8 9.86739 8 10C8 10.1326 7.94732 10.2598 7.85356 10.3536C7.75979 10.4473 7.63261 10.5 7.5 10.5Z"
                      fill="#252526"
                    />
                  </svg>
                </div>
                <p className="text-[13px]/[21px] text-[#252526]">
                  {lead?.phone_number}
                </p>
              </div>
              <div className="flex items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="14"
                  viewBox="0 0 12 14"
                  fill="none"
                >
                  <path
                    d="M6 0C4.54182 0.00165421 3.14383 0.581648 2.11274 1.61274C1.08165 2.64383 0.501654 4.04182 0.5 5.5C0.5 10.2063 5.5 13.7606 5.71313 13.9094C5.7972 13.9683 5.89735 13.9999 6 13.9999C6.10265 13.9999 6.2028 13.9683 6.28687 13.9094C6.5 13.7606 11.5 10.2063 11.5 5.5C11.4983 4.04182 10.9184 2.64383 9.88726 1.61274C8.85617 0.581648 7.45818 0.00165421 6 0ZM6 3.5C6.39556 3.5 6.78224 3.6173 7.11114 3.83706C7.44004 4.05682 7.69638 4.36918 7.84776 4.73463C7.99913 5.10009 8.03874 5.50222 7.96157 5.89018C7.8844 6.27814 7.69392 6.63451 7.41421 6.91421C7.13451 7.19392 6.77814 7.3844 6.39018 7.46157C6.00222 7.53874 5.60009 7.49913 5.23463 7.34776C4.86918 7.19638 4.55682 6.94004 4.33706 6.61114C4.1173 6.28224 4 5.89556 4 5.5C4 4.96957 4.21071 4.46086 4.58579 4.08579C4.96086 3.71071 5.46957 3.5 6 3.5Z"
                    fill="#FD4949"
                  />
                </svg>
                <p className="text-[13px]/[21px] text-[#808285]">
                  {lead?.lead_location}
                </p>
              </div>
            </div>

            {/* Info kunjungan */}
            <div className="py-2 px-6 border-b mb-2 border-dashed border-[#D8D8D9]">
              <p className="text-[11px]/[17px] text-[#808285] mb-2">
                Info kunjungan:
              </p>
              <div className="flex items-center gap-2 mb-2">
                <p className="text-[13px]/[21px] text-[#252526]">
                  {lead?.visit_code}
                </p>
              </div>
              <div className="flex items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M13 2H11.5V1.5C11.5 1.36739 11.4473 1.24021 11.3536 1.14645C11.2598 1.05268 11.1326 1 11 1C10.8674 1 10.7402 1.05268 10.6464 1.14645C10.5527 1.24021 10.5 1.36739 10.5 1.5V2H5.5V1.5C5.5 1.36739 5.44732 1.24021 5.35355 1.14645C5.25979 1.05268 5.13261 1 5 1C4.86739 1 4.74021 1.05268 4.64645 1.14645C4.55268 1.24021 4.5 1.36739 4.5 1.5V2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V13C2 13.2652 2.10536 13.5196 2.29289 13.7071C2.48043 13.8946 2.73478 14 3 14H13C13.2652 14 13.5196 13.8946 13.7071 13.7071C13.8946 13.5196 14 13.2652 14 13V3C14 2.73478 13.8946 2.48043 13.7071 2.29289C13.5196 2.10536 13.2652 2 13 2ZM5.25 11.5C5.10166 11.5 4.95666 11.456 4.83332 11.3736C4.70999 11.2912 4.61386 11.1741 4.55709 11.037C4.50032 10.9 4.48547 10.7492 4.51441 10.6037C4.54335 10.4582 4.61478 10.3246 4.71967 10.2197C4.82456 10.1148 4.9582 10.0434 5.10368 10.0144C5.24917 9.98547 5.39997 10.0003 5.53701 10.0571C5.67406 10.1139 5.79119 10.21 5.8736 10.3333C5.95601 10.4567 6 10.6017 6 10.75C6 10.9489 5.92098 11.1397 5.78033 11.2803C5.63968 11.421 5.44891 11.5 5.25 11.5ZM8 11.5C7.85166 11.5 7.70666 11.456 7.58332 11.3736C7.45999 11.2912 7.36386 11.1741 7.30709 11.037C7.25032 10.9 7.23547 10.7492 7.26441 10.6037C7.29335 10.4582 7.36478 10.3246 7.46967 10.2197C7.57456 10.1148 7.7082 10.0434 7.85368 10.0144C7.99917 9.98547 8.14997 10.0003 8.28701 10.0571C8.42406 10.1139 8.54119 10.21 8.6236 10.3333C8.70601 10.4567 8.75 10.6017 8.75 10.75C8.75 10.9489 8.67098 11.1397 8.53033 11.2803C8.38968 11.421 8.19891 11.5 8 11.5ZM8 9C7.85166 9 7.70666 8.95601 7.58332 8.8736C7.45999 8.79119 7.36386 8.67406 7.30709 8.53701C7.25032 8.39997 7.23547 8.24917 7.26441 8.10368C7.29335 7.9582 7.36478 7.82456 7.46967 7.71967C7.57456 7.61478 7.7082 7.54335 7.85368 7.51441C7.99917 7.48547 8.14997 7.50032 8.28701 7.55709C8.42406 7.61386 8.54119 7.70999 8.6236 7.83332C8.70601 7.95666 8.75 8.10166 8.75 8.25C8.75 8.44891 8.67098 8.63968 8.53033 8.78033C8.38968 8.92098 8.19891 9 8 9ZM10.75 11.5C10.6017 11.5 10.4567 11.456 10.3333 11.3736C10.21 11.2912 10.1139 11.1741 10.0571 11.037C10.0003 10.9 9.98547 10.7492 10.0144 10.6037C10.0434 10.4582 10.1148 10.3246 10.2197 10.2197C10.3246 10.1148 10.4582 10.0434 10.6037 10.0144C10.7492 9.98547 10.9 10.0003 11.037 10.0571C11.1741 10.1139 11.2912 10.21 11.3736 10.3333C11.456 10.4567 11.5 10.6017 11.5 10.75C11.5 10.9489 11.421 11.1397 11.2803 11.2803C11.1397 11.421 10.9489 11.5 10.75 11.5ZM10.75 9C10.6017 9 10.4567 8.95601 10.3333 8.8736C10.21 8.79119 10.1139 8.67406 10.0571 8.53701C10.0003 8.39997 9.98547 8.24917 10.0144 8.10368C10.0434 7.9582 10.1148 7.82456 10.2197 7.71967C10.3246 7.61478 10.4582 7.54335 10.6037 7.51441C10.7492 7.48547 10.9 7.50032 11.037 7.55709C11.1741 7.61386 11.2912 7.70999 11.3736 7.83332C11.456 7.95666 11.5 8.10166 11.5 8.25C11.5 8.44891 11.421 8.63968 11.2803 8.78033C11.1397 8.92098 10.9489 9 10.75 9ZM13 5H3V3H4.5V3.5C4.5 3.63261 4.55268 3.75979 4.64645 3.85355C4.74021 3.94732 4.86739 4 5 4C5.13261 4 5.25979 3.94732 5.35355 3.85355C5.44732 3.75979 5.5 3.63261 5.5 3.5V3H10.5V3.5C10.5 3.63261 10.5527 3.75979 10.6464 3.85355C10.7402 3.94732 10.8674 4 11 4C11.1326 4 11.2598 3.94732 11.3536 3.85355C11.4473 3.75979 11.5 3.63261 11.5 3.5V3H13V5Z"
                    fill="#252526"
                  />
                </svg>
                <p className="text-[13px]/[21px] text-[#808285]">
                  {dayjs(lead?.visit_schedule).format(
                    "dddd, D MMMM YYYY; HH:mm"
                  )}{" "}
                  WIB
                </p>
              </div>
            </div>

            {/* Summary */}
            <div className="py-2 px-6 border-b mb-2 border-dashed border-[#D8D8D9]">
              <p className="text-[11px]/[17px] text-[#808285] mb-2">Summary:</p>
              <p className="text-[13px]/[21px] text-[#252526]">
                {lead?.conversation_summary}
              </p>
            </div>

            {/* Date */}
            <div className="py-2 px-6 flex items-center gap-1 mb-4">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M14 8.00013C14 9.17205 13.6569 10.3183 13.0129 11.2974C12.3689 12.2765 11.4522 13.0456 10.3761 13.5097C9.30001 13.9738 8.11155 14.1126 6.95746 13.909C5.80337 13.7054 4.73417 13.1682 3.88188 12.3639C3.83411 12.3187 3.7957 12.2646 3.76884 12.2046C3.74198 12.1447 3.7272 12.08 3.72535 12.0143C3.72349 11.9486 3.73459 11.8832 3.75802 11.8218C3.78144 11.7603 3.81673 11.7042 3.86188 11.6564C3.95304 11.5599 4.0788 11.5036 4.21148 11.4999C4.27718 11.498 4.3426 11.5091 4.40401 11.5325C4.46542 11.556 4.52161 11.5912 4.56938 11.6364C5.28421 12.3108 6.18193 12.7595 7.15037 12.9266C8.11881 13.0937 9.11501 12.9717 10.0145 12.5759C10.914 12.18 11.6769 11.5279 12.2079 10.7009C12.7389 9.87398 13.0144 8.90889 13 7.92625C12.9856 6.94361 12.6819 5.987 12.127 5.17594C11.572 4.36489 10.7904 3.73535 9.87967 3.36601C8.96897 2.99666 7.96962 2.90387 7.00649 3.09925C6.04336 3.29462 5.15916 3.76949 4.46438 4.46451C4.24375 4.68763 4.03625 4.90701 3.83438 5.12513L4.85375 6.14638C4.92376 6.21631 4.97144 6.30544 4.99076 6.40248C5.01009 6.49952 5.00019 6.60012 4.96231 6.69153C4.92444 6.78294 4.86029 6.86106 4.77799 6.916C4.69569 6.97093 4.59895 7.00021 4.5 7.00013H2C1.86739 7.00013 1.74021 6.94746 1.64645 6.85369C1.55268 6.75992 1.5 6.63274 1.5 6.50013V4.00013C1.49992 3.90119 1.5292 3.80444 1.58414 3.72214C1.63908 3.63985 1.71719 3.5757 1.80861 3.53782C1.90002 3.49995 2.00061 3.49004 2.09765 3.50937C2.1947 3.5287 2.28382 3.57638 2.35375 3.64638L3.125 4.41888C3.32625 4.20076 3.53375 3.98138 3.75375 3.75951C4.59255 2.91928 5.66178 2.34679 6.82609 2.1145C7.99041 1.88221 9.19746 2.00057 10.2945 2.45459C11.3915 2.90861 12.3292 3.67789 12.9888 4.66505C13.6484 5.65221 14.0003 6.81288 14 8.00013ZM8 4.50013C7.86739 4.50013 7.74021 4.55281 7.64645 4.64658C7.55268 4.74035 7.5 4.86753 7.5 5.00013V8.00013C7.49997 8.08645 7.52229 8.17131 7.56479 8.24644C7.60729 8.32158 7.66851 8.38443 7.7425 8.42888L10.2425 9.92888C10.2988 9.9627 10.3612 9.9851 10.4262 9.99479C10.4911 10.0045 10.5574 10.0013 10.6211 9.98539C10.6848 9.96949 10.7448 9.94119 10.7976 9.90211C10.8504 9.86303 10.8949 9.81394 10.9288 9.75763C10.9626 9.70133 10.985 9.63892 10.9947 9.57396C11.0043 9.509 11.0012 9.44277 10.9853 9.37904C10.9694 9.31532 10.9411 9.25535 10.902 9.20256C10.8629 9.14977 10.8138 9.1052 10.7575 9.07138L8.5 7.71701V5.00013C8.5 4.86753 8.44732 4.74035 8.35355 4.64658C8.25979 4.55281 8.13261 4.50013 8 4.50013Z"
                    fill="#808285"
                  />
                </svg>
              </div>
              <p className="text-[13px]/[21px] text-[#252526]">
                {dayjs(lead?.timestamps_leads).format(
                  "dddd, D MMMM YYYY; HH:mm WIB"
                )}
              </p>
            </div>

            {/* Handled */}
            <div className="py-2 px-6 flex items-center gap-1 mb-4 border-t border-solid border-[#D8D8D9]">
              <p className="text-[13px]/[21px] text-[#808285]">
                Ditangani oleh:
                <span className="text-[#252526]"> {lead?.name}</span>
              </p>
            </div>
          </div>

          {/* RIGHT */}
          {hasComments > 0 && (
            <div className="w-full">
              {/* Labels */}
              <div className="h-[40px] w-full flex items-center justify-between gap-2 py-2 px-6 border-b border-l border-t border-solid border-[#D8D8D9]">
                <p className="text-[13px]/[21px] font-semibold text-[#252526]">
                  Aktifitas
                </p>
                {_getBadge(lead?.status_lead)}
              </div>

              <div className="bg-[#FAFAFA] py-2 px-6 border-l h-[calc(500px-40px)] overflow-y-auto border-solid border-[#D8D8D9]">
                {lead?.lead_comments?.map((comment, index) => (
                  <div
                    key={`lead-comment-${index}`}
                    className="border-b border-dashed border-[#D8D8D9] py-2 mb-2"
                  >
                    <p className="text-[11px]/[21px] text-[#808285]">
                      {dayjs(comment?.date).format(
                        "dddd, D MMMM YYYY; HH:mm WIB"
                      )}
                    </p>
                    <p className="text-[13px]/[21px] text-[#252526]">
                      {comment?.content}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalLeadDetail;
